import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SET_USER } from "../../redux/user";
import Avatar from "./Avatar";
import {
  FiUser,
  FiLock,
  FiUsers,
  FiCalendar,
  FiCreditCard,
  FiLogOut,
} from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";

export default function ProfileMenu({ user }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const fullName =
    `${user?.first_name || ""} ${user?.last_name || ""}`.trim() ||
    user?.full_name ||
    user?.name ||
    "Guest";

  const handleLogout = () => {
    localStorage.removeItem("GSTB_token");
    dispatch(SET_USER(null));
    navigate("/");
    setShow(false);
  };

  return (
    <Dropdown align="end" show={show} onToggle={(isOpen) => setShow(isOpen)}>
      <Dropdown.Toggle
        variant="link"
        bsPrefix="p-0 border-0 bg-transparent"
        id="profile-menu-toggle"
        className="text-decoration-none"
      >
        <Avatar user={user} size={38} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="profile-menu p-0">
        <div className="profile-menu-header d-flex align-items-center justify-content-between px-3 py-3 border-bottom">
          <div className="d-flex align-items-center">
            <Avatar user={user} size={44} />
            <div className="ms-3">
              <div className="profile-menu-name inter-semibold">{fullName}</div>
            </div>
          </div>
          <button
            type="button"
            className="profile-menu-close-btn"
            onClick={() => setShow(false)}
          >
            <IoCloseOutline size={20} />
          </button>
        </div>

        <div className="profile-menu-list py-2">
          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={() => {
              navigate("/profile");
              setShow(false);
            }}
          >
            <span className="profile-menu-icon-wrap">
              <FiUser size={20} />
            </span>
            <span className="profile-menu-text">My Profile</span>
          </Dropdown.Item>

          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={() => {
              navigate("/change-password");
              setShow(false);
            }}
          >
            <span className="profile-menu-icon-wrap">
              <FiLock size={20} />
            </span>
            <span className="profile-menu-text">Change Password</span>
          </Dropdown.Item>

          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={() => {
              navigate("/family-member");
              setShow(false);
            }}
          >
            <span className="profile-menu-icon-wrap">
              <FiUsers size={20} />
            </span>
            <span className="profile-menu-text">Family Members</span>
          </Dropdown.Item>

          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={() => {
              // navigate("/event-passes");
              setShow(false);
            }}
          >
            <span className="profile-menu-icon-wrap">
              <FiCalendar size={20} />
            </span>
            <span className="profile-menu-text">Event Tickets</span>
          </Dropdown.Item>

          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={() => {
              navigate("/membership");
              setShow(false);
            }}
          >
            <span className="profile-menu-icon-wrap">
              <FiCreditCard size={20} />
            </span>
            <span className="profile-menu-text">Membership</span>
          </Dropdown.Item>
          <Dropdown.Item
            as="button"
            className="profile-menu-item"
            onClick={handleLogout}
          >
            <span className="profile-menu-icon-wrap logout-icon-wrap">
              <FiLogOut size={20} />
            </span>
            <span className="profile-menu-text text-danger">Logout</span>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
